import { http } from "../ConnectApi/ConnectApi";

export async function refreshTokenController(data: { }) {
  try {
    const response = await http.post('/auth/refresh', data, {
      withCredentials: true
    });

    return response;
  } catch (error: any) {
    console.error('Error during request:', error.response?.data || error.message);
    throw error;
  }
}
